import { css } from '@emotion/react';

import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const wrapper = (spaceX: string, spaceY: string) => css`
  margin-top: ${spaceY}px;
  ${MQ.MobileXs} {
    ${flex('column', 'start', 'start')};
    gap: 8px;
  }
  ${MQ.MediaMd} {
    ${flex('row', 'start', 'center')};
    gap: ${spaceX}px;
  }
`;
